export enum ScheduleStatus {
  Scheduled = 1,
  InProgress = 2,
  Done = 3,
}
